// core/services/councilService.ts — B5: real/derived Council dashboard reads.
//
// The Overview's roster + derivable metrics come from the backend; genuinely
// unsourceable metrics stay as static placeholders in the OverviewSection.

import { api } from '@/core/lib/apiClient';

export interface CouncilTeamView {
  id: string;
  name: string;
  status: string;
  caseload: number;
  members: { name: string; av: string }[];
}
export interface RecentDecisionView {
  caseId: string;
  summary: string;
  outcome: 'removed' | 'kept';
}
export interface AppealView {
  caseId: string;
  summary: string;
  status: string;
}
export interface CouncilStats {
  pendingCases: number;
  resolvedToday: number;
  activeTeams: number;
  openAppeals: number;
  reportsFiled: number;
  removed: number;
  humanReview: number;
}
export interface CouncilOverview {
  teams: CouncilTeamView[];
  recentDecisions: RecentDecisionView[];
  appeals: AppealView[];
  stats: CouncilStats;
}

export const councilService = {
  async overview(): Promise<CouncilOverview> {
    return api<CouncilOverview>('/council/overview/');
  },
  async teams(): Promise<CouncilTeamView[]> {
    return api<CouncilTeamView[]>('/council/teams/');
  },
} as const;
